import React from 'react';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const BaseLeadPage = ({
  form: FormComponent,
  content: ContentComponent,
  children,
  ...props
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ContentComponent, {
      form: /*#__PURE__*/_jsx(FormComponent, {
        ...props
      }),
      ...props
    }), children]
  });
};
export default BaseLeadPage;